import '../../scss/models-show.scss';

require('../common/seeMoreResults');
